module.exports = __webpack_public_path__ + "static/media/bg_footer.4cacbcbb.png";